import { render } from "./Index copy.vue?vue&type=template&id=1877fa3a&ts=true"
import script from "./Index copy.vue?vue&type=script&lang=ts"
export * from "./Index copy.vue?vue&type=script&lang=ts"

import "./Index copy.vue?vue&type=style&index=0&id=1877fa3a&lang=scss&scope=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__